import { Location } from '@angular/common';
import { Component, OnInit, signal, Signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CustomerModel } from '@libs/account/models';
import { ButtonComponent, PageHeaderComponent } from '@libs/common/components';
import { AuthService } from '@libs/shared/auth';
import { OrderCheckoutSuccessRouteDataModel } from '@libs/shop/models';
import { DateTime } from 'luxon';
import { DeliveryWindowsDialogComponent } from '../../delivery-windows-form/delivery-windows-dialog';
import { OrderConfirmationComponent } from '../../order/order-confirmation/order-confirmation.component';
import { CheckoutDetailsComponent } from '../checkout/checkout-details';

@Component({
  selector: 'ui-checkout-success',
  templateUrl: './checkout-success.component.html',
  styleUrl: './checkout-success.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    OrderConfirmationComponent,
    CheckoutDetailsComponent,
    ButtonComponent,
    RouterLink,
    DeliveryWindowsDialogComponent,
    PageHeaderComponent,
  ],
})
export class CheckoutSuccessComponent implements OnInit {
  public customer: Signal<CustomerModel | undefined> = this.authService.currentCustomer;
  public deliveryWindowsRefDate: Signal<DateTime> = signal(DateTime.now());

  public deliveryDate: WritableSignal<DateTime | undefined> = signal(undefined);
  public orderCustomReferenceText: WritableSignal<string | undefined> = signal(undefined);

  public constructor(
    private readonly authService: AuthService,
    private readonly location: Location,
  ) {
  }

  public ngOnInit(): void {
    const routeData: OrderCheckoutSuccessRouteDataModel = this.location.getState() as OrderCheckoutSuccessRouteDataModel;

    if (routeData.deliveryDate) {
      this.deliveryDate.set(DateTime.fromISO(routeData.deliveryDate));
    }

    if (routeData.orderCustomReference) {
      this.orderCustomReferenceText.set(routeData.orderCustomReference);
    }
  }
}
